module.exports = __webpack_public_path__ + "img/drisya.052cf769.png";